import React from "react";
import { Button, Popconfirm } from "antd";
import { CancelWhiteSVG, PrintColorWhiteSVG, SaveWhiteIconSVG } from "assets";

const Save = (handleFunc): JSX.Element => {
  return (
    <Button
      className="custom-btn"
      type="primary"
      htmlType="submit"
      onClick={handleFunc}
      icon={<SaveWhiteIconSVG />}
    >
      Lưu lại
    </Button>
  );
};

const SaveAndPrint = (handleFunc): JSX.Element => {
  return (
    <Button
      className="btn-sub"
      type="primary"
      htmlType="submit"
      onClick={handleFunc}
      icon={<PrintColorWhiteSVG />}
    >
      In kết quả
    </Button>
  );
};

const Completed = (handleFunc, trangThai): JSX.Element => {
  const listDisableTrangThai = [0, 1, 6, 7];
  const disabled = listDisableTrangThai.includes(trangThai);
  return (
    <Button
      className="btn-sub"
      htmlType="submit"
      type="primary"
      onClick={handleFunc}
      disabled={disabled}
      icon={<SaveWhiteIconSVG />}
    >
      Hoàn thành
    </Button>
  );
};

const NextPatient = (handleFunc): JSX.Element => {
  return (
    <Button
      className="btn-sub"
      type="primary"
      htmlType="submit"
      onClick={handleFunc}
      icon={<SaveWhiteIconSVG />}
    >
      Bệnh nhân tiếp theo
    </Button>
  );
};

const Cancel = (handleFunc, trangThai): JSX.Element => {
  const listDisableTrangThai = [0, 3, 6, 7];
  const disabled = listDisableTrangThai.includes(trangThai);
  return (
    <Popconfirm
      title={
        trangThai === 2
          ? "Phiếu khám chưa hoàn thành. Bạn có chắc chắn muốn hủy khám?"
          : "Bạn chắc chắn có muốn hủy khám?"
      }
      onConfirm={handleFunc}
      disabled={disabled}
    >
      <Button
        className="custom-btn"
        type="primary"
        htmlType="submit"
        danger
        disabled={disabled}
        icon={<CancelWhiteSVG />}
      >
        Hủy thực hiện
      </Button>
    </Popconfirm>
  );
};
const Pause = (handleFunc, trangThai): JSX.Element => {
  const listDisableTrangThai = [0, 3, 6, 7];
  const disabled = listDisableTrangThai.includes(trangThai);
  return (
    <Button
      className="custom-btn"
      type="primary"
      htmlType="submit"
      onClick={handleFunc}
      disabled={disabled}
      icon={<SaveWhiteIconSVG />}
    >
      Tạm dừng
    </Button>
  );
};

export { Save, Cancel, Completed, NextPatient, Pause, SaveAndPrint };
